import PublicPageShell from '@/components/Public/PublicPageShell'
import LegalPageLayout, { type LegalSection } from '@/components/Public/LegalPageLayout'

const UPDATED_AT = '2026-04-20'

const SECTIONS: LegalSection[] = [
  {
    id: 'collection',
    title: '一、信息收集',
    body: [
      '为了提供稳定、安全、可计费的 AI API 网关与模型聚合服务，TokenTCP 会在您注册、登录、创建 API Key、调用接口、充值或使用控制台功能时收集必要信息，包括账号信息、认证信息、组织或业务联系人信息、调用元数据、账单与额度流水、设备与网络日志等。',
      '调用元数据可能包括模型名称、渠道类型、请求时间、响应状态、Token 用量、消耗额度、IP 地址、API Key 标识、错误码、延迟指标等。除非您主动开启相关日志能力、提交排障材料、法律法规要求或安全风控必要，TokenTCP 不会以超出实现服务目的的方式主动留存您的完整业务请求内容。',
    ],
  },
  {
    id: 'usage',
    title: '二、信息使用',
    body: [
      'TokenTCP 使用上述信息用于账号鉴权、权限控制、API 调用转发、用量统计、账单结算、额度扣减、异常诊断、安全审计、合规风控、客户支持及服务质量改进。',
      'TokenTCP 不会将可识别到个人或组织的业务请求内容用于模型训练、公开展示或向无关第三方再分发。经聚合、匿名化或去标识化处理且无法识别特定用户的数据，可用于容量规划、稳定性分析和产品优化。',
    ],
  },
  {
    id: 'sharing',
    title: '三、信息共享与委托处理',
    body: [
      '除法律法规要求、监管机关依法调取、履行合同所必需、取得您的明确授权或保护 TokenTCP、用户及公众合法权益所必要的情形外，TokenTCP 不会向无关第三方出售您的个人信息。',
      '当您调用某个上游模型或第三方能力时，请求的必要部分会被转发至对应模型服务提供方、云服务商、支付服务商、邮件服务商或安全风控服务商，并受其服务条款和隐私政策约束。TokenTCP 将尽合理努力选择具备安全与合规能力的合作方，并要求其仅在受托范围内处理相关信息。',
    ],
  },
  {
    id: 'security',
    title: '四、数据安全',
    body: [
      'TokenTCP 采用 TLS 加密传输、凭据哈希存储、敏感密钥加密或脱敏展示、API Key 最小化展示、2FA / Passkey、IP 白名单、权限控制、操作审计、异常告警等措施保护数据安全。',
      '尽管 TokenTCP 将采取合理安全措施，但互联网服务无法保证绝对安全。如发生可能影响您合法权益的数据安全事件，TokenTCP 将按照法律法规要求及时采取补救措施，并通过站内公告、邮件或其他合理方式告知事件情况、影响范围及建议处置步骤。',
    ],
  },
  {
    id: 'cookie',
    title: '五、Cookie 与本地存储',
    body: [
      'TokenTCP 使用必要的 Cookie、localStorage 或同类技术保存登录态、安全校验、主题偏好、侧边栏折叠、列选择器等本地配置。这些技术主要用于维持服务可用性和提升控制台体验，不用于无关的跨站追踪。',
    ],
  },
  {
    id: 'rights',
    title: '六、您的权利',
    body: [
      '您可在个人中心查看或修改账号信息、调整安全设置、解绑第三方登录、管理 API Key，并可依法请求访问、更正、删除、限制处理或注销账号。部分账单、审计、风控及法律法规要求保留的信息，将在必要期限内保存。',
      '如您对本隐私政策或个人信息处理活动有任何疑问，或希望行使相关权利，可通过控制台公告、站内入口或官网 https://tokentcp.com 提供的联系方式与 TokenTCP 联系。',
    ],
  },
  {
    id: 'changes',
    title: '七、政策变更',
    body: [
      '当本政策发生重大变更时，TokenTCP 会在本页面公示，并可通过控制台、站内消息或注册邮箱以显著方式提示。若您在变更生效后继续使用 TokenTCP 服务，即视为您已了解并接受更新后的政策。',
    ],
  },
]

export default function PrivacyPolicy() {
  return (
    <PublicPageShell contentWidth="legal-wide">
      <LegalPageLayout
        title="隐私政策"
        updatedAt={UPDATED_AT}
        intro={
          <>
            TokenTCP（以下简称“本平台”）尊重并保护用户的个人信息与隐私权益。
            为了提供稳定、安全、可计费的 AI API 网关服务，我们会按照本政策处理与账号、调用、计费、安全和客户支持相关的必要信息。
            请您在使用本平台前仔细阅读本政策；继续使用服务即表示您理解并同意本政策的全部内容。
          </>
        }
        sections={SECTIONS}
        relatedLinks={[
          { label: '用户协议', path: '/agreement' },
          { label: '关于我们', path: '/about' },
        ]}
      />
    </PublicPageShell>
  )
}
